(function() { module.exports = window["Bernie_l10nBundle_nb_NO"]; }());